// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import VueLazyload from 'vue-lazyload'
import infiniteScroll from 'vue-infinite-scroll'
import VueCookie from 'vue-cookie'
// import {getShopParam} from './api/index'

// import {
//   Button,
//   Pagination,
//   Checkbox,
//   Radio,
//   RadioButton,
//   RadioGroup,
//   DatePicker,
//   TimePicker,
//   Icon,
//   Switch,
//   Form,
//   FormItem,
//   Autocomplete,
//   Loading,
//   Row,
//   Col,
//   Upload,
//   Message,
//   Notification,
//   Steps,
//   Step,
//   MessageBox,
//   Table,
//   TableColumn,
//   Input,
//   Dialog,
//   Select,
//   Option
// } from 'element-ui'
import ElementUI from 'element-ui'
import {getLocalStorage} from './utils/storage'
import 'element-ui/lib/theme-chalk/index.css'

// Vue.use(Button)
// Vue.use(Pagination)
// Vue.use(Checkbox)
// Vue.use(Radio)
// Vue.use(RadioButton)
// Vue.use(RadioGroup)
// Vue.use(DatePicker)
// Vue.use(TimePicker)
// Vue.use(Upload)
// Vue.use(Icon)
// Vue.use(Switch)
// Vue.use(Autocomplete)
// Vue.use(Steps)
// Vue.use(Row)
// Vue.use(Col)
// Vue.use(Step)
// Vue.use(Form)
// Vue.use(FormItem)
// Vue.use(Table)
// Vue.use(TableColumn)
// Vue.use(Input)
// Vue.use(Dialog)
// Vue.use(Select)
// Vue.use(Option)
// Vue.use(MessageBox.prompt)
// Vue.use(Loading.directive)
// Vue.prototype.$loading = Loading.service
// Vue.prototype.$notify = Notification
// Vue.prototype.$message = Message
// Vue.prototype.$prompt = MessageBox.prompt
Vue.use(ElementUI)
Vue.use(infiniteScroll)
Vue.use(VueCookie)
Vue.use(VueLazyload, {
  preLoad: 1,
  error: '/static/images/aio_image_fail_placeholder.png',
  // loading: '/static/images/loading.gif',
  attempt: 1,
  listenEvents: ['scroll']
})
Vue.config.productionTip = false
const whiteList = ['/home', '/goods', '/login', '/forgot', '/register', '/goodsDetails', '/search', '/refreshsearch', '/refreshgoods', '/refreshlb'] // 不需要登录的页面
router.beforeEach(function (to, from, next) {
  let shopInfo = JSON.parse(getLocalStorage('ShopParam'))
  if (to.meta.title) {
    document.title = to.meta.title
    if (shopInfo && shopInfo.ShopName) {
      document.title = to.meta.title + shopInfo.ShopName
    }
  }

  if (getLocalStorage('UserUUID') && getLocalStorage('UserInfo')) {
    store.commit('RECORD_USERINFO', getLocalStorage('UserInfo'))
    if (to.path === '/login') { // 跳转到
      next({path: '/'})
    }
    next()
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 白名单
      next()
    } else {
      next({
        path: '/login',
        query: {redirect: to.fullPath}
      })
    }
  }
})

new Vue({
  el: '#app',
  store,
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js